import { EnumBase } from 'hay-core-react';
class ContratoUtilizacaoSituacaoEnum extends EnumBase {
    constructor() {
        super(
            [
                'main.contratoutilizacao.situacao.aberto',
                'main.contratoutilizacao.situacao.fechado',
            ],
            'main.contratoutilizacao.situacao.aberto'
        );
    }
}

const instance = new ContratoUtilizacaoSituacaoEnum();
export default instance;
